module.exports = __webpack_public_path__ + "img/sticker-0-3.3e29dc01.png";